import { render, staticRenderFns } from "./newsletterBS.vue?vue&type=template&id=b3cb4a42"
import script from "./newsletterBS.vue?vue&type=script&lang=js"
export * from "./newsletterBS.vue?vue&type=script&lang=js"
import style0 from "./newsletterBS.vue?vue&type=style&index=0&id=b3cb4a42&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports